var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1093_57935)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1093_57935)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.1574,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.083,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.564,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.177,
    cy: 98.318,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.415,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.673 100.347C167.673 137.155 137.569 167.008 100.415 167.008C63.2605 167.008 33.1562 137.155 33.1562 100.347C33.1562 63.5387 63.2605 33.6851 100.415 33.6851C137.569 33.6851 167.673 63.5387 167.673 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.72182,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.2746,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.7785,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.058,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.805,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.578,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.961,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.4,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.676,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.367,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.187,
    cy: 93.5449,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 192.062,
    cy: 77.3154,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.574,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.9238,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.7949,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.5664,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.541,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.4629,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.80075,
    cy: 94.4995,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.6562,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.4746,
    cy: 22.4228,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.9902,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.529,
    cy: 24.8095,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.545,
    cy: 18.8427,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.583 150.347C169.529 150.347 168.674 149.493 168.674 148.438C168.674 147.384 169.529 146.529 170.583 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61914 117.65C7.67363 117.65 8.52846 116.795 8.52846 115.741C8.52846 114.686 7.67363 113.832 6.61914 113.832",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6387 22.4226C75.6932 22.4226 76.548 21.5678 76.548 20.5133C76.548 19.4588 75.6932 18.604 74.6387 18.604",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.939 15.7399C119.885 15.7399 119.03 16.5948 119.03 17.6493C119.03 18.7038 119.885 19.5586 120.939 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 166.934H16.4041M26.4281 155.836V157.388M38.1227 166.934H39.674M26.4281 176.481V178.271M26.4281 180.658V186.982M22.0128 166.934C24.9961 166.934 26.5474 162.638 26.5474 162.638C26.5474 162.638 27.0247 166.934 30.8434 166.934C29.125 166.934 26.6667 168.486 26.4281 171.588C26.4281 171.588 26.1502 169.048 25.2348 168.128C24.4704 167.359 22.0128 166.934 22.0128 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.816 30.0596L172.85 30.0596M162.706 45.8115L162.826 39.6062M151.131 30.0596L149.58 30.0596M162.706 20.7516L162.706 8.57973M167.241 30.0596C164.258 30.0596 162.706 34.3556 162.706 34.3556C162.706 34.3556 162.229 30.0596 158.411 30.0596C160.129 30.0596 162.587 28.5083 162.826 25.4056C162.826 25.4056 163.104 27.9458 164.019 28.8663C164.784 29.6348 167.241 30.0596 167.241 30.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 76.9321,
    cy: 75.3208,
    r: 47.3208,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.9328,
    cy: 75.321,
    r: 38.9172,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4 95.5852C70.8446 95.5852 65.624 93.4204 61.6951 89.4975C57.7662 85.5746 55.6074 80.3481 55.6074 74.7926C55.6074 69.2372 57.7722 64.0166 61.6951 60.0877C65.618 56.1588 70.8446 54 76.4 54C81.9555 54 87.1761 56.1648 91.105 60.0877C95.0339 64.0106 97.1927 69.2372 97.1927 74.7926C97.1927 80.3481 95.0279 85.5686 91.105 89.4975C87.1821 93.4264 81.9555 95.5852 76.4 95.5852ZM76.4 54.2392C70.9104 54.2392 65.7496 56.3801 61.8685 60.2611C57.9875 64.1422 55.8466 69.3029 55.8466 74.7926C55.8466 80.2823 57.9875 85.4431 61.8685 89.3241C65.7496 93.2052 70.9104 95.346 76.4 95.346C81.8897 95.346 87.0505 93.2052 90.9315 89.3241C94.8126 85.4431 96.9535 80.2823 96.9535 74.7926C96.9535 69.3029 94.8126 64.1422 90.9315 60.2611C87.0505 56.3801 81.8897 54.2392 76.4 54.2392Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4008 90.1132C72.3105 90.1132 68.4653 88.5225 65.571 85.6281C62.6766 82.7338 61.0859 78.8886 61.0859 74.7983C61.0859 70.7079 62.6766 66.8628 65.571 63.9684C68.4653 61.0741 72.3105 59.4834 76.4008 59.4834C80.4912 59.4834 84.3363 61.0741 87.2307 63.9684C90.125 66.8628 91.7157 70.7079 91.7157 74.7983C91.7157 78.8886 90.125 82.7338 87.2307 85.6281C84.3363 88.5225 80.4912 90.1132 76.4008 90.1132ZM76.4008 59.7106C72.3703 59.7106 68.5849 61.2774 65.7384 64.1299C62.8919 66.9764 61.3192 70.7618 61.3192 74.7923C61.3192 78.8229 62.8859 82.6082 65.7384 85.4547C68.5849 88.3012 72.3703 89.874 76.4008 89.874C80.4314 89.874 84.2167 88.3072 87.0632 85.4547C89.9097 82.6082 91.4825 78.8229 91.4825 74.7923C91.4825 70.7618 89.9157 66.9764 87.0632 64.1299C84.2167 61.2834 80.4314 59.7106 76.4008 59.7106Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3991 80.7313C73.1221 80.7313 70.4609 78.0702 70.4609 74.7932C70.4609 71.5161 73.1221 68.855 76.3991 68.855C79.6762 68.855 82.3373 71.5161 82.3373 74.7932C82.3373 78.0702 79.6762 80.7313 76.3991 80.7313ZM76.3991 69.0942C73.2596 69.0942 70.7001 71.6536 70.7001 74.7932C70.7001 77.9327 73.2596 80.4921 76.3991 80.4921C79.5387 80.4921 82.0981 77.9327 82.0981 74.7932C82.0981 71.6536 79.5387 69.0942 76.3991 69.0942Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M85.5859 78.5184C90.9296 78.5184 95.2616 74.1864 95.2616 68.8427C95.2616 63.499 90.9296 59.167 85.5859 59.167C80.2421 59.167 75.9102 63.499 75.9102 68.8427C75.9102 74.1864 80.2421 78.5184 85.5859 78.5184Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4 95.5852C70.8446 95.5852 65.624 93.4204 61.6951 89.4975C57.7662 85.5746 55.6074 80.3481 55.6074 74.7926C55.6074 69.2372 57.7722 64.0166 61.6951 60.0877C65.618 56.1588 70.8446 54 76.4 54C81.9555 54 87.1761 56.1648 91.105 60.0877C95.0339 64.0106 97.1927 69.2372 97.1927 74.7926C97.1927 80.3481 95.0279 85.5686 91.105 89.4975C87.1821 93.4264 81.9555 95.5852 76.4 95.5852ZM76.4 54.2392C70.9104 54.2392 65.7496 56.3801 61.8685 60.2611C57.9875 64.1422 55.8466 69.3029 55.8466 74.7926C55.8466 80.2823 57.9875 85.4431 61.8685 89.3241C65.7496 93.2052 70.9104 95.346 76.4 95.346C81.8897 95.346 87.0505 93.2052 90.9315 89.3241C94.8126 85.4431 96.9535 80.2823 96.9535 74.7926C96.9535 69.3029 94.8126 64.1422 90.9315 60.2611C87.0505 56.3801 81.8897 54.2392 76.4 54.2392Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.3928 76.001C58.149 76.001 56.947 76.1684 55.7988 76.4794C55.8945 77.6335 56.0799 78.7578 56.355 79.8521C57.3118 79.5531 58.3344 79.3917 59.3928 79.3917C65.026 79.3917 69.5948 83.9604 69.5948 89.5936C69.5948 91.1484 69.2479 92.6255 68.62 93.9471C69.6665 94.3717 70.7609 94.7185 71.8851 94.9697C72.5968 93.3192 72.9915 91.5072 72.9915 89.5996C72.9855 82.0887 66.8978 76.001 59.3928 76.001Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5473 60.7221C90.1061 59.1733 88.4377 57.8457 86.5838 56.7992C87.7201 57.9593 88.4257 59.544 88.4257 61.2962C88.4257 64.8423 85.5553 67.7128 82.0091 67.7128C78.4629 67.7128 75.5925 64.8423 75.5925 61.2962C75.5925 57.762 78.445 54.8975 81.9732 54.8796C80.2031 54.3832 78.3314 54.1201 76.4058 54.1201C76.1666 54.1201 75.9274 54.1261 75.6882 54.1321C73.7088 55.8842 72.459 58.4437 72.459 61.2962C72.459 66.5766 76.7347 70.8523 82.0151 70.8523C87.2955 70.8523 91.5712 66.5766 91.5712 61.2962C91.5652 61.1048 91.5533 60.9134 91.5473 60.7221Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.082,
    y: 126.82,
    width: 21.5508,
    height: 49.407,
    rx: 4,
    transform: "rotate(-44.8121 113.082 126.82)",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.645 112.437L116.849 123.641",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.049 104.033L125.254 115.238",
    stroke: "#787E8C",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1093_57935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.607422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1093_57935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.607422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b74779d7a8874db176350b4b3bc23f51.svg";
export { ForwardRef as ReactComponent };